<template>
  <founder-board-view :founder-board-alias="founderBoardAlias" :active-founder-id="false"></founder-board-view>

</template>

<script>
import FounderBoardView from "@/client/applications/localstory/views/founderBoard/FounderBoard.vue"
export default {
  layout: 'none',
  components: {
    FounderBoardView
  },
  middleware: {},
  props: {
    founderBoardAlias: {
      type: String,
      default: "",
    },
  },
  setup(props) { },
  data: function () {
    return {};
  },
  computed: {},
  watch: { },
  methods: {},
};
</script>